// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
const escapeRegexString = (str: string): string => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
export const toEscapedRegex = (needle: string, caseInsensitive: boolean): RegExp =>
    new RegExp(escapeRegexString(needle), caseInsensitive ? 'i' : '');
